import styled, { css, keyframes } from 'styled-components';
import { INCENTIVE_MODELS } from '../../../../../constants';

const fadeInDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100%);
  }

  100% {
    position: absolute;
    opacity: 1;
    transform: translateY(0);
    bottom: 0;
  }
`;

const animation = css`
  animation: ${fadeInDown} 0.3s ease-out forwards;
`;

const PayItForwardMobileCss = css`
  .top-content {
    .title {
      font-size: 28px;
    }
    .relevant-rewards {
      img {
        top: 95px;
      }
      img:nth-child(1) {
        height: 90px;
      }
      img:nth-child(2) {
        height: 90px;
      }
    }
  }
  .main-content {
    .subtitle {
      margin: 0 -10px 12px;
      font-size: 18px;
      
      &.no_referral_reward {
        margin: 0 -13px 10px;
        font-size: 16px;
      }
    }
    .sharing-description {
      margin: 0 -15px;
      padding-bottom: ${props => (props.type === 'no_referral_reward' ? 35 : 20)}px;
      font-size: 12px;
      
      &.no_referral_reward {
        margin-top: 30px;
      }
    }
    .how-it-works {
      right: 0px;
    }
    .sharing-type{
      .type-name {
        font-size: 18px;
      }
      .type-img {
        height: 78px;
      }
      .type-description {
        &-wrap {
          margin: 0 -20px;
        }
        &-text {
          &.vanilla_average {
            max-width: 170px;
          }
        }
      }
      .info-line {        
        .keep,
        .forward {
          font-size: 14px;
          span {
            font-size: 18px;
          }
        }
      }
    }
  }
  .no-rewards-terms {
    margin-bottom: 20px;
  }
`;

const PayItForwardCss = css`
  .action-close {
    position: absolute;
    padding: 0;
    top: 10px;
    right: 10px;
    width: 16px;
    height: 16px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    z-index: 1;
    &:focus {
      outline: none;
    }
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }
  .top-content {
    position: relative;
    height: 210px;
    text-align: center;
    overflow: hidden;
    .title {
      position: relative;
      padding: 35px;
      font-size: 32px;
      font-weight: 500;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.16); 
      color: #fff;
    }
    .main-bg,
    .relevant-rewards {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 210px;
    }
    .main-bg {
      img {
        height: 210px;
      }
    }
    .relevant-rewards {
      img {
        position: absolute;
        top: 70px;
      }
      img:nth-child(1) {
        height: 120px;
        left: -30px;
      }
      img:nth-child(2) {
        height: 120px;
        right: -30px;
      }
    }
  }
  .main-content {
    position: relative;
    padding: 0 20px;
    text-align: center;
    background-color: #EFEFEF;
    overflow: hidden;
    .subtitle {
      padding: 10px 0;
      margin: 0 0 12px;
      font-size: 20px;
      font-weight: 500;
      color: #17936F;
      border-bottom: 1px solid #ccc;
      
      &.no_referral_reward {
        margin: 0 0 10px;
        font-size: 18px;
      }
      
      &.referral_reward_per_click {
        i {
          &:before {
            margin: 0 0 0 -4px;
          }
        }
      }

      .reward-with-currency {
        display: inline-block;
        padding: 3px 5px;
        font-size: 24px;
        background-color: #ccc;
        border-radius: 5px;
      }
    }
    .sharing-description {
      position: relative;
      margin: 0;
      padding-bottom: ${props => {
    if (props.isTargetAudience) return '25px';
    else if (props.type === 'no_referral_reward') {
      return '35px';
    }
    return '20px';
  }};
      line-height: 1.25;
      color: #555;
      font-size: 13px;
      
      &.no_referral_reward {
        margin-top: 30px;
        font-size: 15px;
        .how-it-works  {
          bottom: 10px;
        }
        a {
          text-decoration: underline;
        }
      }
    }
    .how-it-works {
      position: absolute;
      bottom: 0;
      right: -15px;
      font-size: 12px;
      text-decoration: underline;
      background-color: transparent;
      color: #999;
      border: none;
      cursor: pointer;
      &:focus {
        outline :none;
      }
      &:hover {
        color: #555555;
      }
    }
    .sharing-type{
      padding: 0 5px 27px;
      padding-bottom: ${props => (((props.type === INCENTIVE_MODELS.VANILLA_POWER_LAW.toLowerCase()) ||
  (props.type === INCENTIVE_MODELS.VANILLA_AVERAGE_LAST_3X.toLowerCase())) ? 15 : 27)}px;
      margin: 0;
      margin-top: 10px;
      width: 100%;
      justify-content: center;
      .type-name {
        width: 100%;
        margin: 0;
        text-align: center;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 500;
        color: #555
      }
      .type-img {
        text-align: center;
        height: 84px;
        img {
          height: 100%;
        }
      }
      .type-description {
        &-wrap {
          position: relative;
          margin: 0;
          text-align: center;
        }
        &-text {
          display: inline-block;
          font-size: 14px;
          font-weight: 500;
          color: #555;
          &.manual {
            max-width: 245px;
          }
          &.vanilla_average_last_3x {
            max-width: 305px;
          }
          &.vanilla_power_law {
            max-width: 238px;
          }
          &.vanilla_average {
            max-width: 100%;
          }
        }
      }
      .manual-slider {
        margin-top: 70px;
        padding: 2px 0;
        width: 100%;
        height: 9px;
        border-radius: 0;
        border-left: 1px solid #7FD9BF;
        border-right: 1px solid #17936F;
        .rc-slider-handle {
          width: 12px;
          height: 12px;
          margin-left: -6px;
          margin-top: -4px;
          background-color: #17936F;
          border-color: #17936F;
          &:focus,
          &:active {
            box-shadow: none;
          }
        }
        .rc-slider-rail {
          height: 5px;
          border-radius: 0;
          background-color: #17936F;
        }
        .rc-slider-track {
          height: 5px;
          border-radius: 0;
          background-color: #7FD9BF;
        }
      }
      .info-line {
        position: relative;
        margin: 0;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        .min-label {
          left: -15px;
        }
        .max-label {
          right: -15px;
        }
        .min-label,
        .max-label {
          position: absolute;
          top: 0;
          font-size: 12px;
          font-weight: 500;
          color: #707070;
        }
        
        .keep,
        .forward {
          margin: 0;
          font-size: 16px;
          font-weight: 500;
          span {
            font-size: 20px;
          }
        }
        .keep {
          color: #707070;
        }
        .forward {
          margin-left: 36px;
          color: #17936F;
        }
        button {
          font-size: 11px;
          text-decoration: underline;
          border: none;
          background-color: transparent;
          color: #999;
          cursor: pointer;
          &[disabled] {
            cursor: not-allowed;
          }
          &.active,
          &:hover {
            color: #707070;
          }
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .no-rewards-terms {
    margin-bottom: 10px;
    font-size: 11px;
    color: #999;
    a {
      text-decoration: underline;
      color: #999;
    }
  }
  
  .continue-button {
    button {
      height: 55px;
      width: 100%;
      margin-bottom: 0;
      border-radius: unset;
    }
  }
  
  @media screen and (max-width: 768px) {
    ${PayItForwardMobileCss}
  }
`;

const NotModalCss = css`
  width: 450px;
`;

const widthNotModal = css`
  width: 450px;
`;

const widthModal = css`
  width: 680px;
  overflow: hidden;
`;

const ModalCss = css`
  position: relative;
  opacity: 1;
  margin: 60px auto;
  width: 680px;
  max-height: 100%;
  background-color: #fff;
  border-radius: 15px;
  transition: transform .3s ease-in-out;
  
  .preview-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50px;
  }

  .smartlink-background {
    position: absolute;
    top: 45%;
    z-index: -1;
  }

  .smartlink-learning {
    position: relative;
    &.absolute {
      position: absolute;
      bottom: 15px
    }
    & > span {
      text-decoration: underline;
      font-size: 12px;
      letter-spacing: 0;
      color: #CCCCCC;
      cursor: pointer;

      &:hover {
        color: darken(#CCCCCC, 20%)
      }
    }

    .smartlink-tooltip__inner {
      display: flex;
      flex: 30% 70%;
      flex-direction: row;
      padding-top: 21px;
      padding-bottom: 21px;
    }
    .smartlink-tooltip__icons {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-right: 24px;
      padding-left: 24px;
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;

        position: relative;

      }
    }

    .smartlink-tooltip__separator {
      height: 30px;
      width: 1px;
      background-color: #fff;
    }
  }



  .smartlink-tooltip__container {
    position: absolute;
    width: 375px;
    padding: 10px 20px;
    top: 0;
    left: 50%;
    background: #00AF91;
    border-radius: 15px;
    opacity: 0;
    transition: opacity 0.3s;
    transform: translate(-50%, -1200px);

    &:after,
    &:before {
      content: '';
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      border: 10px solid transparent;
    }
    &:after {
      border-width: 8px;
      border-top-color: #00AF91;
    }

    &.tooltip-visible {
      opacity: 1;
      z-index: 5;
      transition: opacity 0.3s;
      transform: translate(-50%, -103%);
    }
  }

  .smartlink-tooltip__inner {
    position: relative;
    font-size:11px;
    font-family: Roboto;
    line-height: 11px;
    color: #fff;
    letter-spacing: 0.5px;
  }

  .smartlink-tooltip__close {
    width: 10px;
    height: 10px;
    position: absolute;
    right: 0;

    cursor: pointer;
  }

  @media screen and (max-width: 691px){
    .smartlink-learning {
      position: absolute;
      bottom: 15px;
    }
  }

  .powered-container.absolute-grey {
     position: relative; 
     bottom: unset; 
      left: unset;
    transform: unset;
  }
  .preview-footer {
    display: flex;
    & > div {
      &:first-child {
        margin-right: 15px;
      }

      &:last-child {
        margin-left: 15px;
      }
    }
  }
  .smartlink-earn__container {
    margin-bottom: 70px;
  }
  
  &.withoutMargin {
    position: relative !important;
    //top: 0;
    //margin: 0 auto;
  }
  
  &.flipped {
      transition: transform .3s ease-in-out;
      /*transform: rotateY(180deg);

      .mirror {
        transform: ${props => (props.isMobile ? '' : 'rotateY(180deg)')};
      }*/
    }
  @media screen and (max-width: 768px) {
    &.ReactModal__Content--after-open {
      ${animation};
    }
    opacity: 0;
    margin: 0 auto;
    width: 100%;
    max-height: 100%;
    background-color: #fff;
    border-radius: 0;
  }
  @media (min-width: 551px) {
    margin-top: 100px;
  }
`;
const StyledPayItForward = styled.div`
  ${props => (props.renderWithoutModal ? NotModalCss : ModalCss)}
  ${props => (props.widthNotModal ? widthNotModal : widthModal)}
  ${PayItForwardCss}
`;

export default StyledPayItForward;
